<button *ngIf="showButton" class="btn top-button save-and-navigate" aria-hidden="true" [disabled]="valid==false" (click)="goForward()">NEXT</button>